import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    data: null,
    scopes: [], // Scope codes of the user's role (src/utils/permissions.js)
    error: null
}

export const authSlice = createSlice({
    name: 'authSlice',
    initialState,
    reducers: {
        authActionStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        authActionSuccess: (state, action) => {
            state.loading = false;
            state.data = action?.payload.data;
            state.scopes = action?.payload?.data?.user?.scopes ?? [];
        },
        // Fresh user from /auth/session, so role changes show without a new login.
        authActionSessionUpdate: (state, action) => {
            if (state.data) {
                state.data.user = { ...state.data.user, ...action?.payload };
            }
            state.scopes = action?.payload?.scopes ?? [];
        },
        authActionFailure: (state, action) => {
            state.loading = false;
            state.error = action?.payload;
        },
        authActionLogout: (state) => {
            state.data = null;
            state.scopes = [];
            state.error = null;
        }
    },
});

export const {
    authActionStart,
    authActionSuccess,
    authActionSessionUpdate,
    authActionFailure,
    authActionLogout
} = authSlice.actions;

export default authSlice.reducer;
